import { useState } from 'react';
import { AdminLoginPage } from '@/admin/pages/AdminLoginPage';
import { AdminBrandsPage } from '@/admin/pages/AdminBrandsPage';
import { AdminChartsPage } from '@/admin/pages/AdminChartsPage';
import { AdminImportPage } from '@/admin/pages/AdminImportPage';
import { AdminSettingsPage } from '@/admin/pages/AdminSettingsPage';
import { AdminAuditPage } from '@/admin/pages/AdminAuditPage';
import { adminApi } from '@/admin/adminApi';
import { FitMapLogo } from '@/components/FitMapLogo';

type Tab = 'brands' | 'charts' | 'import' | 'settings' | 'audit';

const TABS: Array<{ id: Tab; label: string }> = [
  { id: 'brands', label: 'Brands' },
  { id: 'charts', label: 'Charts' },
  { id: 'import', label: 'CSV Import' },
  { id: 'settings', label: 'Settings' },
  { id: 'audit', label: 'Audit Trail' },
];

export default function AdminApp() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [tab, setTab] = useState<Tab>('brands');

  if (!loggedIn) {
    return <AdminLoginPage onLoggedIn={() => setLoggedIn(true)} />;
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
      <header className="mb-6 flex items-center justify-between">
        <div>
          <FitMapLogo variant="compact" />
          <h1 className="mt-1 text-xl font-bold text-ink">Admin</h1>
        </div>
        <button
          type="button"
          onClick={async () => {
            await adminApi.logout();
            setLoggedIn(false);
          }}
          className="text-sm font-medium text-muted hover:text-ink"
        >
          Sign out
        </button>
      </header>

      <nav className="mb-6 flex flex-wrap gap-2" aria-label="Admin section">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={`min-h-[40px] rounded-xl px-4 py-2 text-sm font-semibold transition-colors ${
              tab === t.id ? 'bg-brand text-ink shadow-card' : 'bg-white text-ink border border-stone-200'
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      <main>
        {tab === 'brands' && <AdminBrandsPage />}
        {tab === 'charts' && <AdminChartsPage />}
        {tab === 'import' && <AdminImportPage />}
        {tab === 'settings' && <AdminSettingsPage />}
        {tab === 'audit' && <AdminAuditPage />}
      </main>
    </div>
  );
}
